<template>
  <v-container class="pa-0">
    <v-row class="d-flex justify-center">
      <v-col cols="12" class="d-flex justify-center">
        <v-card rounded="lg" width="750" class="flex-grow-0 flex-shrink-0">
          <v-row class="px-4 pb-0 pt-10">
            <v-col :cols="dynamicColsImg" class="d-flex justify-center align-start degradado_card">
              <v-img class="rounded-lg" :src="imagen" :aspect-ratio="16 / 9" contain></v-img>
            </v-col>
            <v-col :class="dynamicPaddingMargin">
              <v-row dense class="fill-height d-flex align-center">
                <v-col cols="12">
                  <v-col cols="12" class="mt-0 mb-0 ml-0 pl-0 pt-0 pb-2">
                    <h3 class="primary--text font-weight-bolder museo-text bolder-text">{{ nombre_plaza }}</h3>
                  </v-col>
                  <v-col cols="12" class="mt-0 mb-0 ml-0 pl-0 pt-0 pb-0">
                    <h4 class="primary--text font-weight-regular">{{ nombre_establecimiento }}</h4>
                  </v-col>
                  <v-col cols="12" class="mt-0 mb-0 ml-0 pl-0 pt-0 pb-0">
                    <h4 class="primary--text font-weight-regular">{{ nombre_unidad }}</h4>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="px-1 pb-4 pt-0 mx-0 my-0">
            <v-col v-if="customBreakpoint" cols="12" sm="12" md="4" class="ml-0 pl-0 mr-0 pr-0"></v-col>
            <v-col class="ml-0 pl-0 mr-0 pr-0">
              <v-row dense class="d-flex justify-space-between pa-0 ma-0">
                <v-col :cols="dynamicColsBtn"
                  :class="[dynamicPaddingMrgBtn, !customBreakpoint ? 'd-flex justify-start' : '']">
                  <v-btn class="text-none rounded-xl" width="215" max-width="215" color="primary" outlined
                    :block="dynamicBtnBlockStyle" @click.stop="$emit('on-click-favorito', id)">
                    <v-icon small color="primary">
                      {{ (item?.favoritos && Array.isArray(item.favoritos) && item.favoritos[0]?.activo) ? 'mdi-heart' :
                      'mdi-heart-outline' }}
                    </v-icon>
                    {{ (item?.favoritos && Array.isArray(item.favoritos) && item.favoritos[0]?.activo) ? 'Quitar de mis favoritos' : 'Agregar a favoritos' }}
                  </v-btn>
                </v-col>
                <v-col :cols="dynamicColsBtn"
                  :class="[dynamicPaddingMrgBtn, !customBreakpoint ? 'd-flex justify-end' : '']">
                  <v-btn width="215" max-width="215" class="text-none rounded-xl pa-0 ma-0" color="primary" dark
                    :block="dynamicBtnBlockStyle" @click="onClickDetalle">
                    Ver oferta
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import imagenPlaza from "@/assets/img/goes-gray.png";
export default {
  name: "CardSugerencias",
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      nombre_unidad: null,
      nombre_plaza: null,
      imagen: null,
      id: null,
      nombre_establecimiento: null,
      windowWidth: window.innerWidth,
    };
  },
  methods: {
    onClickDetalle() {
      this.$emit("on-click-detalle", this.id);
    },
    firstLetterUpperCase(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    screenWidth() {
      return this.windowWidth;
    },
    dynamicColsImg() {
      if (this.screenWidth > 600) {
        return 4;
      }
      if (this.screenWidth > 400) {
        return 6;
      }
      return 12;
    },
    dynamicPaddingMrgBtn() {
      if (this.screenWidth > 960) {
        return 'pa-0 ma-0';
      }
      return 'px-3'
    },
    dynamicPaddingMargin() {
      if (this.screenWidth < 600 && this.screenWidth) {
        return "pa-1.5 ma-1.5";
      }
      if (this.screenWidth > 600) {
        return "pa-0 ma-0";
      }
      return "pa-2 ma-2";
    },
    dynamicColsBtn() {
      let cols = 6
      if (this.screenWidth >= 515 && this.screenWidth < 960) {
        cols = 6
      }
      if (this.screenWidth < 515) {
        cols = 12
      }
      return cols
    },
    customBreakpoint() {
      if (this.screenWidth > 600) {
        return true;
      }
      return false;
    },
    dynamicBtnBlockStyle() {
      if (this.screenWidth <= 960) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    const mimeType = this.item?.solicitud?.UnidadOrganizativa?.estable?.imagen_institucion?.mime_type || '*';
    window.addEventListener("resize", this.handleResize);
    this.nombre_unidad = `${this.firstLetterUpperCase(this.item?.solicitud?.UnidadOrganizativa?.nombre)}`;
    this.nombre_plaza = this.item?.solicitud?.titulo_oferta;
    this.imagen = this.item?.solicitud?.UnidadOrganizativa?.estable?.imagen_institucion?.imagen_base64 ?
      `data:${mimeType};base64,${this.item?.solicitud?.UnidadOrganizativa?.estable?.imagen_institucion?.imagen_base64}` : imagenPlaza;
    this.nombre_establecimiento = this.firstLetterUpperCase(this.item?.solicitud?.UnidadOrganizativa?.estable?.nombre);
    this.id = this.item?.id;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
<style scoped>
.museo-text {
  font-family: 'MuseoSans', sans-serif !important;
}

.bolder-text {
  -webkit-font-smoothing: antialiased;
  text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;

}

.degradado_card .v-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(9, 30, 64, 0) 0%, #091E408C 100%);
  pointer-events: none;
}
</style>
